import React from 'react';
import './Shell.css';
import { ShellViewModel } from './ShellViewModel';
import { SetupUIBindingForReactFunctionalComponent } from '../common/UIBinding';
import Logo from './Logo.png';
import { UserToolbar } from './UserToolbar';
import { SignIn } from './SignIn';
import { SignUp } from './SignUp';
import { UserProfile } from './UserProfile';
import { Debug } from './Debug';
import { Keyboard } from '../keyboard/Keyboard';
import { KeyboardMobile } from '../keyboard/KeyboardMobile';

let viewModel = new ShellViewModel();

export function Shell() {
    SetupUIBindingForReactFunctionalComponent(viewModel);

    React.useEffect(() => {
        viewModel.initialize();

        return () => {
            // Put some unmount logic here.
        };
    }, []);

    return <div className="main absolute fulfill flex-v">
        <span id="log"></span>
        {viewModel.isLoading
            ? <div className="loading" style={{ textAlign: 'center' }}>{viewModel.loadingSource} Loading...</div>
            : (!viewModel.isMobile ?
                <>
                    <div className="header flex-none flex-h" style={{ lineHeight: '80px' }}>
                        <div className="flex-auto logo flex-h" onClick={() => viewModel.goHome()}><img src={Logo} style={{ height: '80px' }} /><span style={{ verticalAlign: 'middle', paddingLeft: '20px' }}>TypeFast</span></div>
                        {viewModel.isHelp ? null : <div className="flex-none user"><UserToolbar viewModel={viewModel.userToolbar} /></div>}
                    </div>
                    <div className="content flex-auto relative">
                        {viewModel.isHelp ?
                            <div className="content-padding absolute flex-v fulfill overflow">
                                Welcome to use TypeFast. TypeFast is an input method which allows you to use your desktop keyboard to type in your phone apps.<br />
                                <br />
                                To get started, please go to your phone -{'>'} Settings -{'>'} General -{'>'} Keyboards -{'>'} Add New Keyboard.
                                Then add TypeFast as your new input method.
                            </div>
                            : <div className="content-padding absolute flex-v fulfill overflow">
                                {(viewModel.uiLocation == 'home' || viewModel.uiLocation == 'code') ? renderHome() : null}
                                {viewModel.uiLocation == 'signin' ? <SignIn viewModel={viewModel.signIn} /> : null}
                                {viewModel.uiLocation == 'signup' ? <SignUp viewModel={viewModel.signUp} /> : null}
                                {viewModel.uiLocation == 'profile' ? <UserProfile viewModel={viewModel.userProfile} /> : null}
                            </div>
                        }
                    </div>
                </>
                : <div className="flex-auto relative"><KeyboardMobile /></div>)
        }
        {viewModel.showSystemMessage ?
            <>
                <div className="system-message">
                </div>
                <div className="system-message-content">{viewModel.systemMessage}</div>
            </>
            : null}
    </div>;

    function renderHome() {
        if (viewModel.isUserSignedIn) {
            return <Keyboard />;
        }

        return <div>
            <p>Welcome to use TypeFast. But it's a quite boring app. It just allows you to connect your desktop keyboard to your phone input method then you can use your desktop keyboard to type with any desktop input methods.</p>
            <p>
                To get started, you need to:<br />
                1, sign up;<br />
                2, sign in;<br />
                3, create a keyboard code;<br />
                4, in your phone, add the TypeFast keyboard in Settings and then switch to TypeFast input method in whichever app you want to type something.<br />
                5, set the keyboard code in TypeFast input method in your phone.<br />
                6, enjoy the high speed typing you get used to with your desktop keyboard.
                </p>
        </div>;
    }
}